import './AnnouncementCard.scss'
import { formatLongDate } from "../../../../utils/date-utils";
import { useState } from 'react';
import { apiGetAnnouncementDocument } from '../api/get-announcement-document';
import { showErrorMessage } from '../../../../utils/messages';
import { Announcement } from '../type/Announcement';
import { useMarkAnnouncementAsRead } from '../api/mark-announcement-as-read';
import { useQueryClient } from '@tanstack/react-query';
import { LoadPagePanel } from '../../../../components';
import SupportPersonIcon from '../../../../assets/images/SupportPerson.svg';


export default function AnnouncementCard(props: { announcement: Announcement }) {

	const [isProcessing, setIsProcessing] = useState(false);
	const queryClient = useQueryClient();

	const markAnnouncementAsRead = useMarkAnnouncementAsRead(props.announcement.announcementID,
		() => {
			queryClient.invalidateQueries(["announcements"]);
			queryClient.invalidateQueries(["unread-announcement-count"]);
		},
		(error) => {
			showErrorMessage(error);
		});

	function downloadDocument(documentID: number, clickEvent: any) {

		if (!clickEvent.target.getAttribute('download')) {
			clickEvent.preventDefault();
			setIsProcessing(true);

			apiGetAnnouncementDocument(documentID)
				.then((result) => {
					if (result.isSuccess) {
						clickEvent.target.href = result.documentUrl;
						clickEvent.target.setAttribute('download', result.fileName);
						clickEvent.target.click();
						clickEvent.target.href = "";
					}
					else {
						showErrorMessage("Document download error: " + result.errorMessage);
					}
				})
				.finally(() => { setIsProcessing(false); });
		}
	}

	function markAsRead(clickEvent: any) {
		clickEvent.preventDefault();
		markAnnouncementAsRead.mutate();
	}

	const message = props.announcement.message; // TODO: sanitize HTML?
	const subject = props.announcement.subject ?? '';

	return (
		<>
			<div className="dx-card announcement" key={props.announcement.announcementID}>
				{
					props.announcement.isActive &&
					<div className="announcement-markasread">
						<a href="" onClick={markAsRead}>Mark as read</a>
					</div>
				}
				<img src={SupportPersonIcon} alt="Support" className="announcement-creator-icon" />
				<div className="announcement-creator-name">
					{'Sage Sync Support'}
				</div>
				<div className="announcement-date">
					{formatLongDate(props.announcement.startDate, true)}
				</div>
				<div className="announcement-subject">
					<span className="announcement-field-label">Subject:</span>
					<span className="announcement-field-value" dangerouslySetInnerHTML={{ __html: subject }}></span>
				</div>
				{
					!!props.announcement.endDate &&
					<div className="announcement-expires">
						<span className="announcement-field-label">Expires:</span>
						<span className="announcement-field-value">{formatLongDate(props.announcement.endDate, true)}</span>
					</div>
				}
				<div className="announcement-message" dangerouslySetInnerHTML={{ __html: message }}></div>
				<div className="announcement-files">
					{
						props.announcement.documents.map((doc) => {
							return <div key={doc.announcementDocumentID}><a
								href=""
								target="_blank"
								onClick={(e) => downloadDocument(doc.announcementDocumentID, e)}
							>
								{doc.fileName}
							</a>
							</div>
						})
					}
				</div>
			</div>
			<LoadPagePanel visible={isProcessing || markAnnouncementAsRead.isLoading} />
		</>
	);
}
